const SignUpStyles = (theme) => ({
	main: {
		"width": 'auto',
		"display": 'block', // Fix IE 11 issue.
		"marginLeft": theme.spacing.unit * 3,
		"marginRight": theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			"width": 400,
			"marginLeft": 'auto',
			"marginRight": 'auto'
		}
	},
	paper: {
		"marginTop": theme.spacing.unit * 8,
		"display": 'flex',
		"flexDirection": 'column',
		"alignItems": 'center',
		"padding": `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: "#ee464e"
	},
	typography: {
		marginTop: theme.spacing.unit * 8,
		marginBottom: theme.spacing.unit,
		textAlign: 'center'
	},
	facebookLogin: {
		marginTop: theme.spacing.unit * 6
	},
	submit: {
		marginTop: theme.spacing.unit * 2,
		marginBottom: theme.spacing.unit
	},
	error: {
		textAlign: 'center',
		color: theme.palette.primary.main,
		marginBottom: -28
	},
	wrapper: {
		position: 'relative'
	},
	buttonProgress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -8,
		marginLeft: -12
	}
});

export default SignUpStyles;
